import type {
  CampusFormValues,
  CampusListItem,
  CampusListParams,
  CampusListResult,
} from '@/types/campus.types';

import { apiClient } from './api.service';

const cleanParams = <T extends Record<string, unknown>>(input: T): Partial<T> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (value === undefined || value === '' || value === null) continue;
    out[key] = value;
  }
  return out as Partial<T>;
};

export const campusesApi = {
  list: (params: CampusListParams): Promise<CampusListResult> =>
    apiClient
      .get<CampusListResult>('/admin/campuses', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  create: (data: CampusFormValues): Promise<CampusListItem> =>
    apiClient.post<CampusListItem>('/admin/campuses', data).then((r) => r.data),

  update: (id: string, data: Partial<CampusFormValues>): Promise<CampusListItem> =>
    apiClient.patch<CampusListItem>(`/admin/campuses/${id}`, data).then((r) => r.data),

  delete: (id: string): Promise<void> =>
    apiClient.delete(`/admin/campuses/${id}`).then(() => undefined),
};
